import moment from 'moment';
import { $ } from '../simpli';
import { toString } from './misc.helper';
export var bool = function (val) {
    return val !== undefined && val !== null ? $.t("boolean." + val) : '';
};
export var datetime = function (date) {
    return date ? moment(date).format($.t('dateFormat.datetime')) : '';
};
export var date = function (date) {
    return date ? moment(date).format($.t('dateFormat.date')) : '';
};
export var time = function (date) {
    return date ? moment(date).format($.t('dateFormat.time')) : '';
};
export var phone = function (val) { return $.filter.phone(toString(val)); };
export var cep = function (val) { return $.filter.cep(toString(val)); };
export var cpf = function (val) { return $.filter.cpf(toString(val)); };
export var cnpj = function (val) { return $.filter.cnpj(toString(val)); };
export var cpfOrCnpj = function (val) { return $.filter.cpfOrCnpj(toString(val)); };
export var rg = function (val) { return $.filter.rg(toString(val)); };
export var pad = function (val, length) { return $.filter.pad(toString(val), length); };
//# sourceMappingURL=filter.helper.js.map